import '@fontsource/space-grotesk';
import { createFont } from 'tamagui';

export const spaceGroteskFont = createFont({
  family: 'Space Grotesk',
  face: {
    300: { normal: 'Space Grotesk' },
    400: { normal: 'Space Grotesk' },
    500: { normal: 'Space Grotesk' },
    600: { normal: 'Space Grotesk' },
    700: { normal: 'Space Grotesk' },
    800: { normal: 'Space Grotesk' },
    900: { normal: 'Space Grotesk' },
  },
  size: {
    1: 10,
    2: 11,
    sm: 11,
    3: 12,
    4: 14,
    true: 14,
    default: 14,
    md: 14,
    5: 16,
    lg: 16,
    6: 18,
    xl: 18,
    7: 20,
    8: 23,
    9: 30,
    10: 46,
    11: 55,
    12: 62,
    13: 75,
    14: 91,
    15: 110,
    16: 134,
  },
  lineHeight: {
    1: 10,
    2: 12,
    sm: 12,
    3: 13,
    4: 16,
    true: 16,
    default: 16,
    md: 16,
    5: 18,
    lg: 18,
    6: 20,
    xl: 20,
    7: 22,
    8: 25,
    9: 34,
    10: 52,
    11: 60,
    12: 70,
    13: 84,
    14: 102,
    15: 124,
    16: 150,
  },
  weight: {
    1: '300',
    2: '400',
    3: '500',
    4: '600',
    5: '700',
    6: '800',
    7: '900',
  },
  letterSpacing: {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    true: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0,
    11: 0,
    12: 0,
    13: 0,
    14: 0,
    15: 0,
    16: 0,
  },
});
